export const TAGS = new Map<string, Array<string>>(
    [
      ['insito', ['insito-subscribe', 'insito-advertise']],
      ['insito_sante', ['insito_sante-subscribe', 'insito_sante-advertise']],
      ['insito_habitat', ['insito_habitat-subscribe', 'insito_habitat-advertise']],
      ['alliance', ['alliance-subscribe', 'alliance-advertise']],
      ['inviseo', ['inviseo-subscribe', 'inviseo-advertise']]
    ]
  );
